import apiClient from './apiClient';

/** @returns {Promise<Array>} */
export async function fetchResumeEvaluationAudit() {
  const { data } = await apiClient.get('admin/resume-evaluation-audit');
  return Array.isArray(data) ? data : [];
}
